import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { Link } from "react-scroll";
import "./footer.scss";

import Logo from '../../assets/footer/VCSS_Logo_f.png';
import Arrow from '../../assets/footer/arrow.svg';

const partnerBox = () => (
  <div className="footer">
    <div className="wrapper">
      <Row >
        <Col xs={12} sm={4} md={4} >
          <div>
            <img src={Logo} alt="logo" style={{
              marginLeft: '23px',
              maxWidth:"20%"
            }}/>
            <p style={{marginTop:"7px"}}>
            The V Connect Security Services(VCSS), a leading provider of job opportunities across Canada. Our mission is to connect job seekers with rewarding employment opportunities in a variety of sectors, including security guard services, Staffing/recruiting services, events, and many others.
            </p>
          </div>
        </Col>
        <Col xs={12} sm={4} md={4} style={{
          marginTop: '5px',
        }}>
          <div className="text-center">
            <h3 style={{color:"white", marginLeft:"7px"}}>Address</h3>
            <p style={{
              marginTop: '15px',
            }}>
              <span style={{color:"rgb(255, 193, 7)"}}>
              VCSS - V Connect Security Services
                </span><br/>
             1063 Douglas McCurdy Cmn<br/>
             Mississauga, ON L5G 0C5<br/>
              <i className="bi bi-envelope" /> {' '}{' '} <a href="mailto:info@vcsscanada.com" className="whiteColor" style={{ textDecoration: "none"}}>info@vcsscanada.com</a><br/>
                    <i className="bi bi-telephone" /> {' '}{' '}
                    <a href="tel:+18773504494" className="whiteColor" style={{ textDecoration: "none"}}>+1 (877) 350-4494</a>
                    <br/>
            </p>
          </div>
        </Col>
        <Col xs={12} sm={4} md={4} style={{
          marginTop: '5px',
        }}>
          <div className="text-center">
            <h3 style={{color:"white"}}>Quick Links</h3>
            <ul style={{marginTop:"15px"}}>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/terms-and-conditions">Terms & Conditions</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/disclaimer">Disclaimer</a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={6}>
          <div className="footer-box">
            <p>© 2026 - <span  style={{
              color: '#FFC107',
            }}>VCSS - V Connect Security Services</span> All Right Reserved</p>
          </div>
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Link to="hero" spy={true} smooth={true} offset={0} duration={500}>
            <div className="footer-box back-to-top">
              <p>BACK TO TOP</p>
              <img src={Arrow} alt="arrow" />
            </div>
          </Link>
        </Col>
      </Row>
    </div>
  </div>
);
export default partnerBox;
